import Subscriber from "messaging/values/subcriber/subscriber";

export default class SubscriberAPIRequest {
    userId: string;
    legalEntityId: string;

    public constructor(subscriber: Subscriber) {
        if (!subscriber) throw new Error("Subscriber must be defined");
        this.userId = subscriber.userId.toString();
        this.legalEntityId = subscriber.entityId.toString();
    }
}